import { render, staticRenderFns } from "./naj-data-table.vue?vue&type=template&id=7edfd48e&scoped=true&"
import script from "./naj-data-table.vue?vue&type=script&lang=js&"
export * from "./naj-data-table.vue?vue&type=script&lang=js&"
import style0 from "./naj-data-table.vue?vue&type=style&index=0&id=7edfd48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edfd48e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VIcon,VPagination})
